export default __webpack_public_path__ + "static/sun-through-trees-e5678c848bc5e528eec25750b33f05e9.jpg";